export default __webpack_public_path__ + "static/media/user-profile.548983d8.svg";